// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultMapPropsMappingSource.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { toJS } from 'mobx';

import MapCollection from 'logic/data/Izenda.MapCollectionConstants';
import uiState from 'logic/Izenda.UiState';
import { getAll } from 'share/factories/Izenda.ReportPartStyleFactories';
import { MAP_TYPES } from 'logic/data/Izenda.ReportPartMapConstants';
import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';
import { get, isEmpty } from 'lodash/fp';

export default (reportPartDetails, fieldStore) => {
  const reportPartContent = reportPartDetails.reportPartContent || {};

  const getProperties = key => {
    if (!key) {
      const properties = reportPartDetails && reportPartDetails.getReportPartProperties();
      const props = toJS(properties);
      return props;
    }

    return reportPartContent.getReportPartProperties(key);
  };

  return {
    isHiddenContinent() {
      return !reportPartContent.isMapStyle(MAP_TYPES.Continent);
    },

    isHiddenCountry() {
      return !reportPartContent.isMapStyle(MAP_TYPES.Country);
    },

    isHiddenState() {
      const countryInfo = get('properties.countryInfo', reportPartContent);
      return !countryInfo || !get('others.STATE_LIST_NAME', countryInfo);
    },

    getStateByCountry() {
      const countryInfo = get('properties.countryInfo', reportPartContent);
      const stateListName = get('others.STATE_LIST_NAME', countryInfo);
      return MapCollection[stateListName] || [];
    },

    isHiddenPartPropertiesConfiguration() {
      return (
        !reportPartContent.isBeingBuild ||
        (reportPartContent.isMapStyle(MAP_TYPES.Google) && isEmpty(uiState.googleApiKey))
      );
    },

    isHiddenBackgroundColor() {
      return reportPartContent.chartType === MAP_TYPES.Google;
    },

    isBeingBuild() {
      return reportPartContent.isBeingBuild;
    },

    getChartType() {
      return reportPartContent.chartType;
    },

    getMapTypeOptions() {
      return getAll(REPORT_PART_TYPE.Map)
        .filter(({ style }) => style !== MAP_TYPES.Google || !isEmpty(uiState.googleApiKey))
        .map(({ label, style, previewCSS }) => ({
          label,
          value: style,
          className: previewCSS
        }));
    },

    getValueByKey: getProperties
  };
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartMap/Izenda.DefaultMapPropsMappingSource.js